import React, { useContext } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import "./PageLoader.css";
import LoaderContext from "../contexts/LoaderContext";

const PageLoader = () => {
  const { isLoading } = useContext(LoaderContext);
  const antIcon = <LoadingOutlined style={{ fontSize: 48 }} spin />;

  if (!isLoading) return null;

  return (
    <div className="page-loader">
      <div className="loader-content">
        <Spin indicator={antIcon} />
        <div className="loader-text">Loading...</div>
      </div>
    </div>
  );
};

export default PageLoader;
